export const Alueet = [
  "Uusimaa 1",
  "Uusimaa 2",
  "Häme 1",
  "Häme 2",
  "Pirkanmaa 1",
  "Pirkanmaa 2"
]

export const AlueTarkennukset = [
  "Helsinki, Espoo, Vantaa, Kauniainen, Sipoo, Kirkkonummi, Vihti, Nurmijärvi, Tuusula, Järvenpää, Kerava.",
  "Hanko, Tammisaari, Porvoo, Inkoo, Siuntio, Lohja, Hyvinkää, Mäntsälä, Pornainen, Pukkila, Askola, Myrskylä, Lapinjärvi, Loviisa",
  "Asikkala, Heinola, Hollola, Lahti, Iitti, Orimattila",
  "Karkkila, Loppi, Hattula, Hämeenlinna, Janakkala, Riihimäki, Hausjärvi, Kärkölä",
  "Tampere, Pirkkala, Lempäälä, Ylöjärvi, Hämeenkyrö, Nokia, Vesilahti, Kangasala, Orivesi, Sastamala, Valkeakoski",
  "Ikaalinen, Parkano, Kihniö, Virrat, Ruovesi, Mänttä-Vilppula, Juupajoki, Pälkäne, Punkalaidun, Akaa, Urjala"
]

export const Palvelut = [
  "Lavan toimitus",
  "Lavan välityhjennys",
  "Lavan poishaku ja tyhjennys",
  "Lavan toimitus ja poishaku"
]

export const Koot = [
  "Pieni auto 6-14 m³",
  "Iso auto 16 – 20m³"
]

export const Wastetypes = [
  ["Asbesti", 267.80, "/tn"],
  ["Asfalttikuorma, iso auto*", 298.70, "/krt"],
  ["Betoni- ja tiilijäte", 59.48, "/tn"],
  ["Bitumijäte", 235.77, "/tn"],
  ["Energiajäte (puhdas, kuiva)", 129.78, "/tn"],
  ["Kaakelijäte", 81.11, "/tn"],
  ["Kannot", 123.60, "/tn"],
  ["Kipsijäte, uusiokäyttöön (puhdas, kuiva)", 97.34, "/tn"],
  ["Kiristekalvomuovi, uusiokäyttöön (puhdas)", 0, "/tn"],
  ["Kokonaiset kuormalavat", 0, "/kpl"],
  ["Kyllästetty puujäte", 323.37, "/tn"],
  ["Lasi", 235.77, "/tn"],
  ["Maa-aines (kantava)**", 11.60, "/tn"],
  ["Maa-aines (savi)**", 21.60, "/tn"],
  ["Maa-aines (liejusavi)**", 55.60, "/tn"],
  ["Metalli***", 0, "/tn"],
  ["Pahvi, uusiokäyttöön (puhdas, kuiva)", 0, "/tn"],
  ["Posliinijäte", 97.34, "/tn"],
  ["Puutarhajäte / Haravointijäte", 129.78, "/tn"],
  ["Rakennusjäte", 181.69, "/tn"],
  ["Rakennusjäte lk.2", 235.77, "/tn"],
  ["Renkaat / kpl", 48.67, "/kpl"],
  ["Risut", 54.08, "/tn"],
  ["Sekalainen puujäte", 54.08, "/tn"],
  ["SER-jäte", 270.38, "/tn"],
  ["SER-jäte / kpl", 48.67, "/kpl"],
  ["Talkoojäte", 181.69, "/tn"],
  ["Villajäte", 181.69, "/tn"]
]

export const WastetypesTampere = [
  ["Asbesti", 267.80, "/tn"],
  ["Betoni- ja tiilijäte (alle 1m x 1m x 1m)", 46.35, "/tn"],
  ["Bitumijäte", 185.40, "/tn"],
  ["Energiajäte (puhdas, kuiva)", 129.78, "/tn"],
  ["Kaakelijäte", 80.86, "/tn"],
  ["Kannot", 123.60, "/tn"],
  ["Kipsijāte, uusiokäyttöön (puhdas, kuiva)", 97.34, "/tn"],
  ["Kiristekalvomuovi, uusiokäyttöön (puhdas)", 0, "/tn"],
  ["Kokonaiset kuormalavat", 0, "/kpl"],
  ["Kyllästetty puujäte", 323.37, "/tn"],
  ["Lasi", 185.40, "/tn"],
  ["Maa-aines (epäpuhdas)**", 68.13, "/tn"],
  ["Maa-aines (puhdas) maankaatomaksu 4-aks**", 144.20, "/krt"],
  ["Maa-aines (puhdas) maankaatomaksu 3-aks**", 123.60, "/krt"],
  ["Maa-aines (puhdas) maankaatomaksu 2-aks**", 92.70, "/krt"],
  ["Metalli***", 0, "/tn"],
  ["Pahvi, uusiokäyttöön (puhdas, kuiva)", 0, "/tn"],
  ["Posliini", 97.34, "/tn"],
  ["Puutarhajäte / Haravointijäte", 129.78, "/tn"],
  ["Rakennusjäte", 185.40, "/tn"],
  ["Rakennusjäte lk.2", 185.40, "/tn"],
  ["Renkaat / kpl", 48.67, "/kpl"],
  ["Risut", 54.08, "/tn"],
  ["Sekalainen puujäte", 46.35, "/tn"],
  ["SER-jäte", 270.38, "/tn"],
  ["SER-jäte/kpl", 46.35, "/kpl"],
  ["Talkoojäte", 185.40, "/tn"],
  ["Villajäte", 185.40, "/tn"]
]

export const WastetypesHame = [
  ["Asbesti", 267.80, "/tn"],
  ["Asfalttikuorma, iso auto*", 298.70, "/krt"],
  ["Betoni- ja tiilijäte", 59.48, "/tn"],
  ["Bitumijäte", 235.77, "/tn"],
  ["Energiajäte (puhdas, kuiva)", 129.78, "/tn"],
  ["Kaakelijäte", 81.11, "/tn"],
  ["Kannot", 123.60, "/tn"],
  ["Kipsijäte, uusiokäyttöön (puhdas, kuiva)", 97.34, "/tn"],
  ["Kiristekalvomuovi, uusiokäyttöön (puhdas)", 0, "/tn"],
  ["Kokonaiset kuormalavat", 0, "/kpl"],
  ["Kyllästetty puujäte", 323.37, "/tn"],
  ["Lasi", 235.77, "/tn"],
  ["Maa-aines (ylijäämä)", 10.30, "/tn"],
  ["Maa-aines (savi)", 15.45, "/tn"],
  ["Metalli**", 0, "/tn"],
  ["Pahvi, uusiokäyttöön (puhdas, kuiva)", 0, "/tn"],
  ["Posliinijäte", 97.34, "/tn"],
  ["Puutarhajäte / Haravointijäte", 129.78, "/tn"],
  ["Rakennusjäte", 181.69, "/tn"],
  ["Rakennusjäte lk.2", 235.77, "/tn"],
  ["Renkaat / kpl", 48.67, "/kpl"],
  ["Risut", 54.08, "/tn"],
  ["Sekalainen puujäte", 54.08, "/tn"],
  ["SER-jäte", 270.38, "/tn"],
  ["SER-jäte / kpl", 48.67, "/kpl"],
  ["Talkoojäte", 181.69, "/tn"],
  ["Villajäte", 181.69, "/tn"]
]

export const WasteCO2 = [
  {name: "Betoni- ja tiilijäte",co2: "16.305"},
  {name: "Kipsijäte",co2: "9.014"},
  {name: "Haravointijäte",co2: "2.187"},
  {name: "Puujäte (puhdas, kyllästämätön)",co2: "9.903"},
  {name: "Rakennusjäte, luokka I",co2: "815.936"},
  {name: "Rakennusjäte, luokka II",co2: "555.640"},
  {name: "Asfaltti",co2: "12.024"},
  {name: "Sekajäte",co2: "406.328"},
  {name: "Biojäte",co2: "3.521"},
  {name: "Metalliromu",co2: "137.251"},
  {name: "Pakkaus- ja energiajäte",co2: "1688.829"},
  {name: "Katujen puhdistusjäte",co2: "0.582"},
  {name: "SER-romu",co2: "707.133"},
  {name: "Autonrenkaat",co2: "850.222"},
  {name: "Vaaralliset jätteet",co2: "1423.153"},
  {name: "Ylijäämämaa-aines",co2: "1.224"},
  {name: "Louhe/ylijäämä kiviaines",co2: "0.783"},
  {name: "Muovi",co2: "1139.500"}
]

export const UnusualTimes = [
  ["Ma-pe erityisaikaan", 94.5*1.03],
  ["Lauantaisin", 157.5*1.03],
  ["Sunnuntaisin", 262.5*1.03],
  // ["Pikatoimitus arkisin (2h)", 105]
]

export const KipRent = {daily: 5.25*1.03, monthly: 157.50*1.03}


//Alue, palvelu, koko
export const priceForSelection = (alue, palvelu, koko) => {
  var price = 0;
  if (alue === 0 || alue === 1 || alue === 2 || alue === 3) {
    if ( palvelu === 0 && koko === 0 ) { price = 63 }
    if ( palvelu === 0 && koko === 1 ) { price = 73.5 }
    if ( palvelu === 1 && koko === 0 ) { price = 147 }
    if ( palvelu === 1 && koko === 1 ) { price = 168 }
    if ( palvelu === 2 && koko === 0 ) { price = 147 }
    if ( palvelu === 2 && koko === 1 ) { price = 168 }
    if ( palvelu === 3 && koko === 0 ) { price = 210 }
    if ( palvelu === 3 && koko === 1 ) { price = 241.5 }
    if ( alue === 1 || alue === 3 ) { price *= 1.2 }
  }
  if ( alue === 4 ) {
    if ( palvelu === 0 && koko === 0 ) { price = 60 }
    if ( palvelu === 0 && koko === 1 ) { price = 80 }
    if ( palvelu === 1 && koko === 0 ) { price = 120 }
    if ( palvelu === 1 && koko === 1 ) { price = 140 }
    if ( palvelu === 2 && koko === 0 ) { price = 120 }
    if ( palvelu === 2 && koko === 1 ) { price = 140 }
    if ( palvelu === 3 && koko === 0 ) { price = 180 }
    if ( palvelu === 3 && koko === 1 ) { price = 220 }
   }
   if ( alue === 5 ) {
     if ( palvelu === 0 && koko === 0 ) { price = 80 }
     if ( palvelu === 0 && koko === 1 ) { price = 100 }
     if ( palvelu === 1 && koko === 0 ) { price = 150 }
     if ( palvelu === 1 && koko === 1 ) { price = 175 }
     if ( palvelu === 2 && koko === 0 ) { price = 150 }
     if ( palvelu === 2 && koko === 1 ) { price = 175 }
     if ( palvelu === 3 && koko === 0 ) { price = 230 }
     if ( palvelu === 3 && koko === 1 ) { price = 275 }
  }
  return price*1.03;
}
